import { useCallback, useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";

function SubscriptionModal({
  open,
  onOpenChange,
  currentPlan = 2,
  onSelectPlan,
  onManageSubscription,
  billingType,
}) {
  const [billingCycle, setBillingCycle] = useState(billingType);

  const plans = [
    {
      id: 1,
      name: "Standard",
      description:
        "Great for solo creators and small publishers who want quick insights without complexity.",
      monthlyPrice: 40,
      features: [
        "1 Domain",
        "$400 billed yearly",
        "1,000 Responses/mo",
        "200 AI Requests/mo",
      ],
      buttonText: "Select",
    },
    {
      id: 2,
      name: "Pro",
      description:
        "Perfect for growing publishers who need deeper audience data and more AI-driven insights.",
      monthlyPrice: 100,
      features: [
        "1 Domain",
        "$1,000 billed yearly",
        "10K Responses/mo",
        "1,000 AI Requests/mo",
      ],
      buttonText: "Select",
      showManageLink: true,
    },
    {
      id: 3,
      name: "Business",
      description:
        "Built for established publishers managing multiple brands or properties at scale.",
      monthlyPrice: 300,
      features: [
        "5 Domains",
        "$3,000 billed yearly",
        "50K Responses/mo",
        "3,000 AI Requests/mo",
      ],
      buttonText: "Select",
    },
    {
      id: 4,
      name: "Enterprise",
      description:
        "Ideal for large media groups that need custom solutions, high volume, and dedicated support.",
      monthlyPrice: null, // Custom pricing
      features: [
        "Unlimited Domains",
        "Custom Pricing",
        "50K+ Responses/mo",
        "3,000+ AI Requests/mo",
      ],
      buttonText: "Talk to Sales",
    },
  ];

  // Helper function to get the display price based on billing cycle
  const getDisplayPrice = (plan) => {
    if (plan.monthlyPrice === null) {
      return "Custom Pricing";
    }

    if (billingCycle === "yearly") {
      const yearlyPrice = plan.monthlyPrice * 10;
      return `$${yearlyPrice} / year`;
    } else {
      return `$${plan.monthlyPrice} / month`;
    }
  };

  const isCurrentPlan = useCallback(
    (planId) => {
      return billingCycle === billingType && currentPlan === planId;
    },
    [billingCycle, billingType, currentPlan]
  );

  return (
    <Modal
      show={open}
      onHide={() => onOpenChange(false)}
      centered
      size="xl"
      dialogClassName="subscription-modal"
    >
      <Modal.Header className="custom-modal-header" closeButton>
        <Modal.Title>Choose your Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body className="subscription-body">
        <div className="billing-toggle">
          <button
            className={`billing-option ${
              billingCycle === "monthly" ? "active" : ""
            }`}
            style={{
              borderTopLeftRadius: "38px",
              borderBottomLeftRadius: "38px",
            }}
            onClick={() => setBillingCycle("monthly")}
          >
            Pay Monthly
          </button>
          <button
            className={`billing-option ${
              billingCycle === "yearly" ? "active" : ""
            }`}
            style={{
              borderTopRightRadius: "38px",
              borderBottomRightRadius: "38px",
            }}
            onClick={() => setBillingCycle("yearly")}
          >
            <span>
              {currentPlan !== 5 && billingType === "monthly"
                ? "Upgrade to Annual"
                : "Pay Annually"}
            </span>
            <span className="billing-free">2 Months Free!</span>
          </button>
        </div>

        {/* Pricing Cards */}
        <Row className="mt-4">
          {plans.map((plan) => (
            <Col key={plan.id} md={6} lg={3} className="mb-4">
              <div
                className={`plan-card ${
                  isCurrentPlan(plan.id) ? "current-plan" : ""
                }`}
              >
                {isCurrentPlan(plan.id) && (
                  <div className="plan-active-bar"></div>
                )}
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-desc">{plan.description}</p>
                <hr className="plan-divider" />
                <div className="plan-price">{getDisplayPrice(plan)}</div>
                <div className="plan-features">
                  {plan.features.map((f, i) => (
                    <div key={i}>{f}</div>
                  ))}
                </div>
                <Button
                  variant={isCurrentPlan(plan.id) ? "primary" : "outline-dark"}
                  className="w-100 mt-3"
                  onClick={() => {
                    if (plan.id === currentPlan) {
                      // onManageSubscription();
                      return;
                    }
                    if (plan.id === 4) {
                      // Enterprise plan - open Calendly link
                      window.open(
                        "https://calendly.com/sidedpolls/30min",
                        "_blank"
                      );
                      return;
                    }
                    onSelectPlan?.(plan.id, billingCycle);
                  }}
                >
                  {isCurrentPlan(plan.id) ? "Current Plan" : plan.buttonText}
                </Button>
                <div className="plan-footer">
                  {isCurrentPlan(plan.id) ? (
                    <button
                      className="manage-link"
                      onClick={onManageSubscription}
                    >
                      Manage Subscription
                    </button>
                  ) : (
                    <span className="cancel-anytime">Cancel any time</span>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* <div className="text-center mt-3">
          <button className="feature-comparison">
            See full feature comparison
          </button>
        </div> */}
      </Modal.Body>
    </Modal>
  );
}

export default SubscriptionModal;
